// =============================================================================
// GLOSARIUM ISTILAH TERPUSAT — 2026-06-14 (user request).
// Satu sumber kebenaran untuk semua LABEL status UI berbahasa Indonesia.
// Aturan: file ini HANYA memetakan key backend/enum (TIDAK berubah) → label
// tampilan. Menambah/mengubah wording cukup di file ini — komponen mengimpor
// dari sini, bukan hardcode label lokal.
// =============================================================================

/** Label status umum lintas fitur (invoice, issue, approval, dsb.). */
export const COMMON_STATUS_LABEL = {
  open: "Terbuka",
  closed: "Ditutup",
  paid: "Lunas",
  overdue: "Terlambat",
  pending: "Menunggu",
  approved: "Disetujui",
  rejected: "Ditolak",
  verified: "Terverifikasi",
  in_review: "Sedang Ditinjau",
  decision_required: "Perlu Keputusan",
  in_progress: "Sedang Dikerjakan",
  resolved: "Terselesaikan",
  needs_verification: "Perlu Verifikasi",
  active: "Aktif",
  standby: "Standby",
  cancelled: "Dibatalkan",
  completed: "Selesai",
};

/** Status tugas (Kanban / Pusat Pekerjaan). Key = enum backend task. */
export const TASK_STATUS_LABEL = {
  todo: "Belum Dimulai",
  in_progress: "Sedang Dikerjakan",
  menunggu_verifikasi: "Menunggu Verifikasi",
  selesai: "Selesai",
  ditolak: "Perlu Revisi",
  dibatalkan: "Dibatalkan",
};

/** Prioritas tugas (key memang bahasa Indonesia di DB — label = key). */
export const PRIORITY_LABEL_ID = {
  Rendah: "Rendah",
  Sedang: "Sedang",
  Tinggi: "Tinggi",
  Kritis: "Kritis",
};

/** Status siklus proyek. Key = enum backend; label untuk tampilan. */
export const PROJECT_STATUS_LABEL = {
  active: "Aktif",
  standby: "Standby",
  overdate: "Terlambat",
  close: "Selesai",
  cancelled_by_owner: "Dibatalkan Pemberi Kerja",
  awaiting_payment: "Selesai",
  completed: "Selesai",
  cancelled: "Selesai",
};

/** Severity isu kritis. */
export const SEVERITY_LABEL = {
  low: "Rendah",
  medium: "Sedang",
  high: "Tinggi",
  critical: "Kritis",
};

/** Status invoice di modul Collection & Retention. */
export const COLLECTION_STATUS_LABEL = {
  paid: "Lunas",
  open: "Terbuka",
  overdue: "Terlambat",
  needs_verification: "Perlu Verifikasi",
  needs_classification: "Perlu Klasifikasi",
  incomplete: "Data Tidak Lengkap",
};

/** Status review penerimaan (proses persetujuan bukti transfer). */
export const REVIEW_STATUS_LABEL = {
  draft: "Menunggu Verifikasi",
  NEEDS_REVIEW: "Perlu Review",
  approved: "Terverifikasi",
  verified: "Terverifikasi",
  VERIFIED_REFERENCE: "Terverifikasi (Referensi)",
  rejected: "Ditolak",
};

/** Kategori klasifikasi penerimaan berlebih — satu sumber label lintas halaman
 *  (selaraskan dgn CATEGORIES di backend/routers/overreceived.py). */
export const OVERRECEIVED_CATEGORY_LABEL = {
  overpayment: "Kelebihan Bayar",
  dp_advance: "DP/Uang Muka",
  retention: "Retensi",
  misallocation: "Salah Alokasi",
  historical_legacy: "Penerimaan Historis",
  unidentified: "Belum Teridentifikasi",
  other: "Lainnya",
};

/** Label tindakan tombol umum — pakai ini, jangan hardcode di komponen. */
export const ACTION_LABEL = {
  save: "Simpan",
  saving: "Menyimpan…",
  cancel: "Batal",
  delete: "Hapus",
  edit: "Ubah",
  add: "Tambah",
  export: "Ekspor",
  download: "Unduh",
  search: "Cari…",
  reset: "Atur Ulang",
  close: "Tutup",
  back: "Kembali",
  detail: "Detail",
  confirm: "Konfirmasi",
  retry: "Coba Lagi",
  refresh: "Muat Ulang",
  view_all: "Lihat Semua",
};
